import { Column } from "@tanstack/react-table";
import z from "zod";

import { CategoryAndTag } from "api/generated/model";
import { TagsFilter } from "components/filters/TagsFilter";
import { useValidatedTSTFilterValue } from "components/table/tsTable/useValidatedTSTFilterValue";
import { buildExtractedTagCategories } from "org/dashboard/utils/filterUtils";

interface TagsFilterProps<TData> {
    placeholder: string;
    tags: Record<string, string[]>[];
    setFilterValue: (value: CategoryAndTag[]) => void;
    column: Column<TData>;
    value: CategoryAndTag[] | null;
}
export function TSTValidStringTagsFilter<TData>({
    placeholder,
    tags,
    setFilterValue,
    column,
    value,
}: TagsFilterProps<TData>) {
    const extractedTagCategories = buildExtractedTagCategories(tags);

    // Validate only the value's shape. A well-formed selection is kept even when
    // its category/tag isn't in the current dataset (the table then shows no
    // rows) rather than being reset — only malformed values are dropped.
    const schema = z
        .array(
            z.object({
                categoryName: z.string(),
                tagName: z.string(),
            })
        )
        .nullable();

    const validatedValue = useValidatedTSTFilterValue(value, schema, column);
    if (validatedValue === undefined) {
        return null;
    }

    return (
        <TagsFilter
            placeholder={placeholder}
            tagCategories={extractedTagCategories}
            value={validatedValue ?? []}
            onChange={setFilterValue}
        />
    );
}
